var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGarlic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d0cfce",
    d: "M23.3922,28.2316a14.9321,14.9321,0,0,0-1.4625.7992A15.273,15.273,0,0,0,14.6325,41.975c0,8.3124,8.3359,15.2821,16.9124,15.2821h9.2294c8.5765,0,17.3808-6.97,17.3808-15.2821a15.2738,15.2738,0,0,0-7.334-12.9666c-.1755-.0913-.5667-.3017-1.0809-.6-2.4494-1.42-7.57-5.2052-8.7459-9.1391H31.8268c-.5127,5.0859-9.1691,9.4064-9.8971,9.7612l-.0713.0347"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9a",
    d: "M50.9321,29.0655s-.0408-.0206-.111-.0571q-.5271-.3212-1.0809-.6c-.1156-.0579-.2275-.1221-.3448-.1771"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.3363,21.2727A58.1686,58.1686,0,0,0,33.0742,11.03,2.4549,2.4549,0,0,1,35.5364,8.775l.9394.0014c1.6873,0,2.07.6932,2.4746,2.3313l2.4041,9.6,7.3393,15.9259a13.7507,13.7507,0,0,1,2.0444,7.1994A14.3687,14.3687,0,0,1,36.16,57.9825,14.3686,14.3686,0,0,1,21.5811,43.8333,13.725,13.725,0,0,1,23.01,37.7562"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.9591,
    d: "M23.01,37.7562a14.0256,14.0256,0,0,1,1.2417-2.068"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.9591,
    d: "M31.3363,21.2727a58.0316,58.0316,0,0,0,1.7543-10.4751,2.1554,2.1554,0,0,1,2.1465-2.023l1.2387.0018c1.6873,0,2.07.6932,2.4746,2.3313l2.1765,8.6043.2262.8738a4.8279,4.8279,0,0,0,.1879.527l6.7209,14.584c1.0973,2.1763,2.4763,5.5042,2.4763,8.1365A14.3687,14.3687,0,0,1,36.16,57.9825,14.3686,14.3686,0,0,1,21.5811,43.8333,13.725,13.725,0,0,1,23.01,37.7562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.9591,
    d: "M31.2916,21.4349s.0178-.0633.0447-.1622"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.9591,
    d: "M31.3363,21.2727c.0809-.2806.1537-.5528.2086-.8065"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.9591,
    d: "M22.9327,37.8805s.0266-.0428.0768-.1243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.9591,
    d: "M24.2512,35.6882c2.0515-3.479,5.8961-10.2926,7.0851-14.4155"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.9591,
    d: "M23.01,37.7562c.1728-.2813.6271-1.0255,1.2417-2.068"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.9591,
    d: "M31.8268,19.27c-.5127,5.0859-9.1691,9.4064-9.8971,9.7612l-.0713.0347"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.9591,
    d: "M41.0122,57.18c8.364-.3419,17.1429-7.1037,17.1429-15.2047a15.2738,15.2738,0,0,0-7.334-12.9666c-.1755-.0913-.5667-.3017-1.0809-.6-2.4494-1.42-7.8942-5.005-8.72-9.1391l-.027-.1064"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.9591,
    d: "M23.3922,28.2316a14.9321,14.9321,0,0,0-1.4625.7992A15.273,15.273,0,0,0,14.6325,41.975c0,7.9861,8.7026,14.7648,16.9124,15.2821"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.9591,
    d: "M50.9321,29.0655s-.0408-.0206-.111-.0571q-.5271-.3212-1.0809-.6c-.1156-.0579-.2425-.1624-.4111-.2423"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.3161,
    x2: 30.5367,
    y1: 57.9825,
    y2: 62.7545,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.9591
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.5842,
    x2: 36.4618,
    y1: 58.3781,
    y2: 62.4288,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.9591
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.5231,
    x2: 42.3357,
    y1: 57.9887,
    y2: 62.7482,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.9591
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarlic);
export default __webpack_public_path__ + "static/media/garlic.45166a81a3c0aca277cd929eacb57b5b.svg";
export { ForwardRef as ReactComponent };